<div class="default-footer" [ngClass]="isLogin ? 'login-footer' : 'footer'">
    {{ currentYear }} &copy; - {{ "software_owned_by" | lang }} Mining<span
        class="tag"
        >TAG</span
    >
    S.A.
</div>
<div class="version-footer flex justify-content-center" *ngIf="showVersion">
    {{ version }}
</div>
